import SERVICE_URL from "../config/API_DATA"
import BaseConfiguration from "../config/base.js"
import HttpPost from "../http/httppost.js";
import Logger from './logger.js';
import { TRIP,CITIZEN,DATE_TIME_FORMAT } from "../util/constants.js";
import { formatDate } from "../util/date/dateFunctions.js"
import {
  LOG_TYPE,
  FILE_NAME 
} from "../config/API_DATA";
export default class SearchResult {
  static buildRequest(pSearchObj,pPassCode) {
    let returnValue = null;
    let retBody = this.formatSearchObject(pSearchObj,pPassCode);


    try {
      let body = retBody

      returnValue = body;
    } catch (err) {
      let body = Logger.buildRequest(FILE_NAME.API_SEARCH_WITHOUT_MARKUP, "error in building body for SearchResult api", err.toString(), "buildRequest", LOG_TYPE.ERROR);
      Logger.getResponse(body);
    }
    return returnValue;
  }

  static async getResponse(pReqOptions) {
    let returnValue = null;
    try {

      returnValue = await HttpPost.makeHttpPostRequest(SERVICE_URL.GET_SEARCH_WITHOUT_MARKUP, pReqOptions);

    } catch (err) {

      let body = Logger.buildRequest(FILE_NAME.API_SEARCH_WITHOUT_MARKUP, "error in getting Response from  SearchResult api ", err.toString(), "getResponse", LOG_TYPE.ERROR);
      Logger.getResponse(body);
    }
    // console.log(returnValue);
    return returnValue;

  }
  ///to format a search object
  static formatSearchObject(pSearchObj,pPassCode) {
    let retValue = null;
    try {
      if (BaseConfiguration.isDebug) console.log("formatSearchObject");

      let searchFormat = {
        searchOption: {
          Route: {
            From: null,
            To: null,
            DepDate: null,
            RetDate: null
          },
          JourneyType: 1,
          PaxInfo: {
            IsDomesticPassenger: false,
            paxCount: {
              Adults: 1,
              Child: 1,
              Infants: 0
            }
          },
          preferredCurrency: null
        },
        passCode:pPassCode
      };
  if(pSearchObj.trip!=TRIP.MULTI_CITY){
      searchFormat.searchOption.Route.From =
        pSearchObj.route[TRIP.ONE_WAY - 1].from.depcode.airportcode;
      searchFormat.searchOption.Route.To =
        pSearchObj.route[TRIP.ONE_WAY - 1].to.depcode.airportcode;
      // searchFormat.searchOption.Route.DepDate =
      //    pSearchObj.route[TRIP.ONE_WAY - 1].date;
      searchFormat.searchOption.Route.DepDate = formatDate(pSearchObj.route[TRIP.ONE_WAY - 1].date, DATE_TIME_FORMAT.API_DATE_FORMAT)
      if (pSearchObj.trip == TRIP.ROUND_TRIP) {
        ///if round trip
        // if (pSearchObj.route[TRIP.ONE_WAY].date == null) {
        //   let retDate = new Date(new Date().setDate(new Date(search.route[0].date).getDate() + 7))
        //   searchFormat.searchOption.Route.RetDate =
        //     formatDate(retDate, DATE_TIME_FORMAT.API_DATE_FORMAT);
        // } else {
          searchFormat.searchOption.Route.RetDate =
            formatDate(pSearchObj.route[TRIP.ONE_WAY].date, DATE_TIME_FORMAT.API_DATE_FORMAT);
        // }
      } else {
        ///if not
        searchFormat.searchOption.Route.RetDate = null;
      }
    }else{
      searchFormat.searchOption.Route=[];
      let routeList=[];
          for(let routeIndex=0;routeIndex<pSearchObj.route.length;routeIndex++){
            let routeObj={
              "From": pSearchObj.route[routeIndex].from.depcode.airportcode,
              "To": pSearchObj.route[routeIndex].to.depcode.airportcode,
              "DepDate":  formatDate(pSearchObj.route[routeIndex].date,DATE_TIME_FORMAT.API_DATE_FORMAT)
          };
            routeList.push(routeObj);
          }
          searchFormat.searchOption.Route=routeList;
    }

      searchFormat.searchOption.JourneyType = pSearchObj.trip;
      searchFormat.searchOption.PaxInfo.paxCount.Adults =
        pSearchObj.pax.adultCount;
      searchFormat.searchOption.PaxInfo.paxCount.Child =
        pSearchObj.pax.childCount;
      searchFormat.searchOption.PaxInfo.paxCount.Infants =
        pSearchObj.pax.infantCount;
        if(pSearchObj.currency)
        {
      searchFormat.searchOption.preferredCurrency = pSearchObj.currency.currency_code.code;
        }
        if(pSearchObj.citizen){
        if(pSearchObj.citizen.code==CITIZEN.MYANMAR.code){
          searchFormat.searchOption.PaxInfo.IsDomesticPassenger=true;
        }else{
          searchFormat.searchOption.PaxInfo.IsDomesticPassenger=false;
        }
      }

      retValue = searchFormat;
    } catch (err) {
      let body = Logger.buildRequest(
        FILE_NAME.API_SEARCH_WITHOUT_MARKUP,
        "error while formating object",
        err.toString(),
        "formatSearchObject",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
    return retValue;
  }

}